import FlowHelper from '../helper/flow';
import {API} from '@/vue-plugins/api';
import moment from 'moment';
const o = {
  namespaced: true,
};

o.state = {
  ready: false,
  tasks: [],
  computedTasks: [],
  taskTree: [],
  history: [],
  historyIndex: -1,
  selected_id: null,
};

o.getters = {
  tasks(state) {
    return state.tasks;
  },
  computedTasks(state) {
    return state.computedTasks;
  },
  taskTree(state) {
    return state.computedTasks.filter((v)=>!v.parent_id);
  },
  is_ready(state) {
    return state.ready;
  },
  root(state) {
    return state.tasks[0];
  },
  selected(state) {
    return state.tasks.find((v)=>v.id == state.selected_id) || {};
  },
  can_undo(state) {
    return state.historyIndex > -1;
  },
  can_redo(state) {
    return state.history.length > state.historyIndex + 1;
  },
  history(state) {
    return state.history;
  },
  historyIndex(state) {
    return state.historyIndex;
  },
  actions(state) {
    const actions = Object.keys(FlowHelper.actions).map((action)=>{
      const v = FlowHelper.actions[action];
      if (v.tool) {
        return {
          action,
          ...v.tool,
        };
      } else {
        return null;
      }
    }).filter((v)=>v);

    if (state.selected_id) {
      return actions;
    } else {
      return [];
    }
  },
};

o.actions = {
  load({commit}, id) {
    if (!id) {
      return;
    }
    return new Promise((resolve)=>{
      if (id == 'create') {
        setTimeout(()=>{
          commit('init');
          resolve();
        }, 1000);
      } else {
        API.get('/tasks/'+id).then((res)=>{
          commit('load', res.data.data);
          resolve();
        });
      }
    });
  },
  save() {

  },

};

o.mutations = {
  do(state, {
    action,
    data,
  }) {
    const actionCaller = FlowHelper.actions[action];
    if (!actionCaller) {
      throw new Error('action is not exist');
    }
    const historyData = actionCaller.do(state, data);
    if (state.historyIndex > 0 && state.history.length > state.historyIndex + 1) {
      state.history = state.history.slice(0, state.historyIndex+1);
    }

    state.historyIndex = state.historyIndex + 1;


    o.mutations.compute(state);

    state.history.push({
      action,
      created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
      data: historyData,
      name: actionCaller.name,
    });
  },
  undo(state) {
    if (history.length <= state.historyIndex) {
      throw new Error('can not undo anything');
    }
    const historyNode = state.history[state.historyIndex];
    state.historyIndex--;
    const action = FlowHelper.actions[historyNode.action];
    if (!action) {
      throw new Error('action is not exist');
    }
    const replacedData = action.undo(state, historyNode.data);
    if (replacedData) {
      historyNode.data = replacedData;
    }
    o.mutations.compute(state);
  },
  redo(state) {
    if (historyNode == 0) {
      throw new Error('historyNode is 0,can not redo anything');
    }
    const historyNode = state.history[state.historyIndex+1];
    state.historyIndex++;
    const action = FlowHelper.actions[historyNode.action];
    if (!action) {
      throw new Error('action is not exist');
    }
    action.do(state, historyNode.data);
    o.mutations.compute(state);
  },
  select(state, id) {
    state.selected_id = id;
  },
  init(state) {
    const task = FlowHelper.init_model();
    state.tasks = [task];
    state.computedTasks = FlowHelper.compute(state.tasks);
    state.ready = true;
  },
  load(state, tasks) {
    state.tasks = tasks;
    state.computedTasks = FlowHelper.compute(state.tasks);
    state.ready = true;
  },
  compute(state) {
    state.computedTasks = FlowHelper.compute(state.tasks);
  },
};

export default o;
